import { useQueryClient } from '@tanstack/react-query';
import { CellContext } from '@tanstack/react-table';
import { toast } from 'react-toastify';
import { IDataTableRef } from 'src/components/DataTable/shared/types';
import { getAcceptedFlashProductsQueryKey } from '../services/api/get-accepted-flash-products';
import useBulkCancelFlashDiscount from '../services/hooks/use-bulk-cancel-flash-discount';
import type { IAcceptedFlashProductListItem } from '../services/models/flash-discount';

interface IProps {
  cellContext: CellContext<IAcceptedFlashProductListItem, unknown>;
  dataTableRef: React.RefObject<IDataTableRef | null>;
  /** Verilirse "İptal Et" tıklanınca doğrudan API yerine bu çağrılır (onay modalı açılır). */
  onRequestRowCancel?: (id: number) => void;
}

export default function IncludedFlashProductsActionCell(props: IProps) {
  const { cellContext: ctx, dataTableRef, onRequestRowCancel } = props;
  const queryClient = useQueryClient();
  const row = ctx?.row?.original;
  const rowId = row?.periodInfo?.[0]?.id;

  const { mutate: bulkCancelDiscount, isLoading: isCanceling } = useBulkCancelFlashDiscount({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getAcceptedFlashProductsQueryKey() });
      dataTableRef.current?.clearSelection?.();
      toast.success('Flaş ürün indirimi iptal edildi.');
    },
    onError: (err: any) => {
      toast.error(err?.response?.data?.message || err?.message || 'İptal işlemi sırasında bir hata oluştu.');
    },
  });

  const handleCancel = () => {
    if (rowId == null) return;
    if (onRequestRowCancel) {
      onRequestRowCancel(rowId);
    } else {
      bulkCancelDiscount({ flashDiscountIds: [rowId] });
    }
  };

  const loadingState = isCanceling;

  return (
    <div className="d-flex flex-wrap gap-2 align-items-center">
      <button type="button" className="btn btn-sm btn-light-danger" disabled={loadingState} onClick={handleCancel}>
        {isCanceling ? <span className="spinner-border spinner-border-sm me-1" /> : null}
        İptal Et
      </button>
    </div>
  );
}
